/**
 * Custom request headers that AuthService.callV2API may emit on the wire.
 * Backend CORS allowedHeaders must include these names case-insensitively.
 */
export const SENT_CUSTOM_HEADERS = [
  'Content-Type',
  'Authorization',
  'X-Tenant-ID',
  'X-Tenant-Subdomain',
  'X-Tenant-Context',
  'X-Request-ID',
  'X-Client-Version',
  'X-User-Agent',
] as const;
